export const routeParamsState = {
    defaultState: {
        routeParams: {},
    },
    actions: {
        setRouteParams: (params, state) => ({...state, routeParams: params}),
    },
}
